import PrefectureForm from "../components/PrefectureForm";
import { message } from 'antd'
import service from "../../../../@services"
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";


const PrefectureEdit = (props => {
    const { search } = useLocation()
    const [id] = useState(search.split("id=")[1])
    const [defaultValue, setDefaultValue] = useState({})
    const fn = (params) => {
        return service.prefecture.mallZoneUpdate(params).then(res => {
            props.history.go(-1)
            message.success("编辑成功")
        }).catch(err => {
            return Promise.resolve(true)
        })
    }
    useEffect(() => {
        id && service.prefecture.mallZoneDetail(id).then(res => {
            setDefaultValue(res)
        })
    }, [id])
    return (
        <PrefectureForm action="edit" title='编辑专区' fn={fn} defaultValue={defaultValue} id={id} />
    );
})

export default PrefectureEdit